export interface AdminChildRow {
  id: string;
  firstName: string;
  lastName: string;
  isMinor: string;
  status: string;
  hasChildren: string;
  children: AdminChildRow[];
}

export function createEmptyChild(): AdminChildRow {
  return {
    id: crypto.randomUUID(),
    firstName: "",
    lastName: "",
    isMinor: "",
    status: "",
    hasChildren: "",
    children: [],
  };
}
